import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const IntegrationServerToAgentHeaderCell = ({
  _customRowProps: { integration },
}: HeaderCellProps) => {
  return <div>Integration Server To Agent</div>;
};

export default IntegrationServerToAgentHeaderCell;
